import { tv } from '~/utils/tv'

export const modalHeaderStyles = tv({
  base: 'min-w[100%] row flex h-[72px] max-h-[72px] min-h-[72px] items-center gap-twopulse rounded-tl-mediumcontainer rounded-tr-mediumcontainer rounded-br-none rounded-bl-none border-[#e6e6e6] border-t-quarterpulse border-r-quarterpulse border-b-none border-b-none border-l-quarterpulse bg-[#FFF] pt-fourpulse pb-twopulse pl-sixpulse',
})
